/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FileDtoFromJSON, FileDtoToJSON, } from './';
export function ServiceActionHistoryDtoFromJSON(json) {
    return ServiceActionHistoryDtoFromJSONTyped(json, false);
}
export function ServiceActionHistoryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'startDateTime': !exists(json, 'startDateTime') ? undefined : (new Date(json['startDateTime'])),
        'endDateTime': !exists(json, 'endDateTime') ? undefined : (new Date(json['endDateTime'])),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : json['attachments'].map(FileDtoFromJSON)),
    };
}
export function ServiceActionHistoryDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
        'startDateTime': value.startDateTime === undefined ? undefined : (value.startDateTime.toISOString()),
        'endDateTime': value.endDateTime === undefined ? undefined : (value.endDateTime.toISOString()),
        'type': value.type,
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : value.attachments.map(FileDtoToJSON)),
    };
}
